import { combinedClassNameSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getUrl } from "@client/lib/settings";
import { TargetSelector, combinedSettingsSelector, makeTextStyleSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type IconBoxesComponentProps } from "./component";
import { makeIconStyleSelector } from "./selectors";

const makeMapStateToProps = () => {
  const iconStyleSelector = makeIconStyleSelector();
  const textStyleSelector = makeTextStyleSelector(TargetSelector.Entity);

  const classNameSelector = combinedClassNameSelector(
    TargetSelector.Entity,
    ["iconBoxesAlign", "iconBoxesSize", "iconStyle"],
    "icon-box effect text-center"
  );

  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    "description",
    "level",
    { name: "icon", prop: "iconClassName" },
    "title",
    { name: "url", converter: getUrl, prop: "url" },
    "urlType"
  ]);
  return (state: AppState, props: RootContainerProps): IconBoxesComponentProps => {
    const settings = settingsSelector(state, props);

    return {
      className: classNameSelector(state, props),
      iconStyle: iconStyleSelector(state, props),
      isEditMode: state.isEditMode,
      textStyle: textStyleSelector(state, props),
      ...settings,
      ...props
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
